if (!customElements.get("sample-pack-selectors")) {
  class SamplePackSelectors extends HTMLElement {
    connectedCallback() {
      this.addEventListener("change", (e) => {
        if (e.target.type !== "radio") return;
        const selector = e.target.closest(".sample-pack-selector");
        if (!selector) return;
        const hidden = selector.querySelector('input[type="hidden"]');
        if (hidden) hidden.value = e.target.value;
      });
    }
  }

  customElements.define("sample-pack-selectors", SamplePackSelectors);
}
